import {
  LocaleProvider as LinearLocaleProvider,
  ToastProvider as LinearToastProvider,
  TooltipProvider as LinearTooltipProvider,
  type Locale as FxLocale,
} from '@flex-design-system/fx';
import { NowFromServerContextProvider } from '@flex-packages/datetime-react/hooks';
import type { Locale } from '@flex-packages/i18n-base';
import type { ReactNode } from 'react';

import UserAgentFromServerContextProvider from './UserAgentFromServerContextProvider';

interface Props {
  locale: Locale;
  now: number;
  userAgent: string;
  children: ReactNode;
}

/** @flex-design-system/fx 가 아직 ja 를 지원하지 않아 ko 로 fallback. fx 가 ja 를 지원하면 제거. */
const toFxLocale = (locale: Locale): FxLocale => {
  switch (locale) {
    case 'ja':
      return 'ko';
    case 'ko':
    case 'en':
      return locale;
  }
};

export function CommonsProvider({ locale, now, userAgent, children }: Props) {
  return (
    <NowFromServerContextProvider nowFromServer={now}>
      <UserAgentFromServerContextProvider userAgent={userAgent}>
        <LinearLocaleProvider locale={toFxLocale(locale)}>
          <LinearToastProvider>
            <LinearTooltipProvider>{children}</LinearTooltipProvider>
          </LinearToastProvider>
        </LinearLocaleProvider>
      </UserAgentFromServerContextProvider>
    </NowFromServerContextProvider>
  );
}
